export default function passwordValidator(password: string) {
  let result = '';
  if (password.length < 8) {
    result = result + 'length';
  }
  if (!password.match(/[a-z]+/)) {
    result = result + 'lower';
  }
  if (!password.match(/[A-Z]+/)) {
    result = result + 'upper';
  }
  if (!password.match(/\d+/g)) {
    result = result + 'digit';
  }
  if (!password.match(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]+/)) {
    result = result + 'special';
  }
  return result ? result : undefined;
}
